import { useDispatch, useSelector } from 'react-redux';
import { 
    selectAmanCurrentStepIndex, 
    selectAmanCurrentSubstepIndex, 
    selectAmanFlowType, 
    setCurrentStepIndex, 
    setCurrentSubstepIndex, 
    setFlowType 
} from '../redux/features/amanFlowSlice';
import { new_aman_flow } from './amanFlowData';

const useAmanFlow = () => {
    const dispatch = useDispatch();
    const flowType = useSelector(selectAmanFlowType);
    const currentStepIndex = useSelector((state) => selectAmanCurrentStepIndex(state));
    const currentSubstepIndex = useSelector((state) => selectAmanCurrentSubstepIndex(state));

    const steps = new_aman_flow[flowType] || [];
    const currentStep = steps[currentStepIndex] || {};
    const currentSubstep = currentStep.substeps ? currentStep.substeps[currentSubstepIndex] : '';

    const handleFlowChange = (type, currentStepIndex, currentSubstepIndex) => {
        dispatch(setFlowType({ type, currentStepIndex, currentSubstepIndex }));
    };

    const handleNextSubstep = () => {
        if (currentStep.substeps && currentSubstepIndex < currentStep.substeps.length - 1) {
            dispatch(setCurrentSubstepIndex(currentSubstepIndex + 1));
        }
        else if (currentSubstepIndex === currentStep.substeps.length - 1) {
            handleNextStep();
        }
    };

    const handlePrevSubstep = () => {
        if (currentSubstepIndex > 0) {
            dispatch(setCurrentSubstepIndex(currentSubstepIndex - 1));
        }
        else {
            handlePrevStep();
        }
    };

    const handleNextStep = () => {
        if (currentStepIndex < steps.length - 1) {
            dispatch(setCurrentStepIndex(currentStepIndex + 1));
        }
    };

    const handlePrevStep = () => {
        if (currentStepIndex > 0) {
            const previousStep = steps[currentStepIndex - 1] || {};
            const substepIndex = previousStep?.substeps?.length - 1 || 0;
            dispatch(setCurrentStepIndex(currentStepIndex - 1));
            dispatch(setCurrentSubstepIndex(substepIndex));
        }
    };

    return {
        handleFlowChange,
        handleNextSubstep,
        handlePrevSubstep,
        handleNextStep,
        handlePrevStep,
        flowType,
        steps,
        currentStep,
        currentStepIndex,
        currentSubstep,
        currentSubstepIndex,
    };
};

export default useAmanFlow;
